// import useIsDesktop from "@hooks/useIsDesktop"
import useNavigationLinks from "@hooks/useNavigationLinks"
import useRouter from "@hooks/useRouter"
import useUser from "@hooks/useUser"

// import { faIcon } from "@utils/faIcon"
import filterUserLinks from "@utils/filterUserLinks"

// import { Button } from "@atoms/index"
import { NavTopBar } from "@organisms"

import { AppFrame } from "@templates"

// import JobSeriesCreateDialog from "@pages/JobSeries/JobSeriesCreateDialog/JobSeriesCreateDialog"
import JobSeriesTableView from "@pages/JobSeries/JobSeriesList/views/JobSeriesTableView/JobSeriesTableView"

import { objectMap } from "@constants/objectMap"

function JobSeriesListContent() {
    const { user } = useUser()
    const router = useRouter()
    // const isDesktop = useIsDesktop()
    const { jobs: jobsLink } = useNavigationLinks()

    const sublinks = filterUserLinks(jobsLink.subLinks, user)

    return (
        <>
            <NavTopBar.Root>
                <NavTopBar.Header>
                    <NavTopBar.NavTopBarHeaderStart>
                        <NavTopBar.PageTitle
                            label={objectMap.job_series.labelPlural}
                            icon={objectMap.job_series.iconActive}
                            navigationItems={
                                sublinks.length > 1
                                    ? sublinks.map((item) => ({
                                          label: item.label,
                                          value: item.path,
                                          isActive: item.label === objectMap.job_series.labelPlural,
                                      }))
                                    : undefined
                            }
                            onNavigationItemSelect={(item) => {
                                router.push(item.value)
                            }}
                        />
                    </NavTopBar.NavTopBarHeaderStart>
                    <NavTopBar.NavTopBarHeaderEnd>
                        <NavTopBar.PagePresence />
                        {/* TODO: Re-enable create new job series CTA
                                <JobSeriesCreateDialog>
                                    <Button
                                        size={isDesktop ? "md" : "lg"}
                                        variant="solid"
                                        leftIcon={faIcon({ name: "plus", style: "solid" })}
                                        noDebounce={true}
                                    >
                                        {isDesktop ? "New" : null}
                                    </Button>
                                </JobSeriesCreateDialog>
                                */}
                    </NavTopBar.NavTopBarHeaderEnd>
                </NavTopBar.Header>
            </NavTopBar.Root>
            <JobSeriesTableView />
        </>
    )
}

export default function JobSeriesList() {
    return (
        <AppFrame.Root collaborationRoomName="job-series-list">
            <JobSeriesListContent />
        </AppFrame.Root>
    )
}
